export const Draft = {
    id: 1,
    value: 'DRAFT',
    name: 'Draft',
};
export const Active = {
    id: 2,
    value: 'ACTIVE',
    name: 'Active',
};
export const Completed = {
    id: 3,
    value: 'COMPLETED',
    name: 'Completed',
};
export const Deleted = {
    id: 4,
    value: 'DELETED',
    name: 'Deleted',
};
export const OnHold = {
    id: 5,
    value: 'ON_HOLD',
    name: 'On Hold',
};
const Basic = [Draft, Active, Completed, OnHold, Deleted];
const BasicByValue = Basic.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
const BasicProps = Object.keys(BasicByValue);
export default {
    Basic,
    BasicByValue,
    BasicProps,
};
